<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M5 15H11.6667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.5 18.3333H17.5"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.6663 18.3333C13.2134 18.3333 14.6972 17.7187 15.7911 16.6248C16.8851 15.5308 17.4997 14.0471 17.4997 12.5C17.4997 10.9529 16.8851 9.46917 15.7911 8.37521C14.6972 7.28125 13.2134 6.66666 11.6663 6.66666H10.833"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.5 11.6667H9.16667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.49967 10C7.05765 10 6.63372 9.8244 6.32116 9.51184C6.0086 9.19928 5.83301 8.77536 5.83301 8.33333V5H10.833V8.33333C10.833 8.77536 10.6574 9.19928 10.3449 9.51184C10.0323 9.8244 9.60837 10 9.16634 10H7.49967Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.0003 5V2.5C10.0003 2.27898 9.91253 2.06702 9.75625 1.91074C9.59997 1.75446 9.38801 1.66666 9.16699 1.66666L7.50033 1.66666C7.27931 1.66666 7.06735 1.75446 6.91107 1.91074C6.75479 2.06702 6.66699 2.27898 6.66699 2.5V5"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconObserver',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#6489B9'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
